import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'appTruncate'
})
export class AppTruncatePipe implements PipeTransform {

  transform(value: string, ...args: any[]): any {
    const limit = args.length > 0 ? parseInt(args[0], 10) : 20;
    const trail: string = args.length > 1 ? args[1] : '...';
    return value.length > limit ? `${value.substring(0, limit)}${trail}` : value;
  }
}
